import CustomCheckBox from 'components/V2/CustomInputs/CustomCheckBox';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';

const AdditionalCredential = props => {
  const { checked, onClick, title, id, name, suggested, key, value, onChange, error } = props;
  const inputRef = useRef(null);

  useEffect(() => {
    if (checked && value === '') {
      inputRef.current?.focus();
    }
  }, [checked, value]);

  if (suggested) {
    return (
      <div className="additional-credential gotham-medium-font" key={key}>
        <CustomCheckBox
          id={id}
          name={name}
          checked={checked}
          onClick={onClick}
          className="label-font-size"
          center
        >
          {title}
        </CustomCheckBox>
      </div>
    );
  }

  return (
    <div className="other-additional-credential" key={key}>
      <div className="inputs-section">
        <CustomCheckBox id={id} name={name} checked={checked} onClick={onClick} className="label-font-size" />
        <input
          ref={inputRef}
          className={classNames('form-control nimbus-regular-font', { 'border-danger shadow-none': error })}
          type="text"
          name={name}
          disabled={!checked}
          value={value}
          onChange={onChange}
          required
          maxLength="255"
          placeholder={checked && value === '' ? '' : 'Other'}
        />
      </div>
      {error && <div className="error nimbus-regular-font">{error}</div>}
    </div>
  );
};

export default AdditionalCredential;
